import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class TeamsTeamRoute extends Route {
  @service store;
  @service router;
  @service users;

  model(params) {
    return this.store
      .findRecord('team', `${params.team}`, {
        filters: { archived: false },
      })
      .catch((err) => {
        if (err?.errors?.[0]?.status === '404') {
          this.router.transitionTo('company');
          return;
        }
        throw err;
      });
  }
}
export default instrumentRoutePerformance(TeamsTeamRoute);
